import { render, staticRenderFns } from "./ku-service.vue?vue&type=template&id=85ab82f2"
var script = {}
import style0 from "./ku-service.vue?vue&type=style&index=0&id=85ab82f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports